import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-about-content',
    templateUrl: './about-content.component.html',
    styleUrls: ['./about-content.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
